export enum RolloutTarget {
  CertifiedUser_Navigate_Dashboard,
  CertifiedUser_Component_GlobalSearch,
  CertifiedUser_Navigate_Projects,
  CertifiedUser_Navigate_Clients,
  CertifiedUser_Navigate_Reports,
  CertifiedUser_Navigate_Participants
}
